<div>
  <div>
    <div>
      @for (
        name of [
          'SPRITE_BUTTON_PRIMARY',
          'SPRITE_BUTTON_SECONDARY',
          'SPRITE_BUTTON_DISABLED',
          'SPRITE_BUTTON_ICON',
          'SPRITE_BUTTON_ICON_HIGHLIGHT',
          'SPRITE_TAB_NORMAL',
          'SPRITE_TAB_OPEN',
          'SPRITE_PANEL_PRIMARY',
          'SPRITE_PANEL_SECONDARY',
          'SPRITE_SCROLLBAR_BACKGROUND',
          'SPRITE_SCROLLBAR_HANDLE',
          'SPRITE_ICON_INVENTORY',
          'SPRITE_ICON_ARROW',
          'SPRITE_PANEL_SLOT',
          'SPRITE_PANEL_SLOT_HIGHLIGHTED',
          'SPRITE_PANEL_INVENTORY',
          'SPRITE_HEADER_PRIMARY',
          'SPRITE_BUTTON_RIGHT',
          'SPRITE_BUTTON_WRONG',
        ];
        track name
      ) {
        <h1>{{ name }}</h1>
        <div>
          @let _sprite = getSprite(name);
          @if (_sprite) {
            @for (s of [0.5, 1, 1.5]; track $index) {
              <app-style-sheet-sprite [sprite]="scale(_sprite.container, s)" style="display: block; width: 400px">
                <p>
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sed animi ipsum quos nostrum? Aut itaque soluta architecto
                  voluptatum modi? Enim.
                </p>
              </app-style-sheet-sprite>
            }
          }
        </div>
      }
    </div>
  </div>
</div>
